<script>

import forminput from "@/router/views/FormComponet/forminput.vue";
import Drawer from "vue-simple-drawer";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader"; 
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import StrBirimHarcamaLimit from "@/models/StrBirimHarcamaLimit";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import Detay from "./Detay.vue";
import store from "@/state/store"; 
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}


export default {
  mixins: [Api, Sabit, StrBirimHarcamaLimit],
  page: {
    title: "Birim Harcama Limit",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Drawer,
    PageHeader,
    AddEdit,
    Detay,
    forminput,BirimSecimi,Treeselect
  },
  data() {
    return {
      title: this.$t("StrBirimHarcamaLimit.Title"),
      items: [
        {
          text: this.$t("StrBirimHarcamaLimit.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrBirimHarcamaLimit.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrBirimHarcamaLimit.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      DataUpdate2: "",
      AddEdit: "",
      FilitrelemePenceresi: false,
      Filter: {
        Hesapkoduid: null,
        Birimid: null,
        Yil: null, 
      },
      siralama:"&Asc=Hesapkodu",
      AdminRoleKontrol: false,
    };
  },

  validations: {
    Filter: {
      Hesapkoduid: {},
      Birimid: {},
      Yil: {}, 
    },
  },
  methods: {
    Get() {
      var Filter =""
       Filter += ((this.Filter.Birimid != null) && (this.Filter.Birimid != "1")) ? "&Birimid="+this.Filter.Birimid : ""
       Filter += this.Filter.Hesapkoduid != null ? "&Hesapkoduid="+this.Filter.Hesapkoduid : ""
       Filter += this.Filter.Yil != null ? "&Yil="+this.Filter.Yil : ""

       if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }

    
      this.ActionsFilterGet({ 
        Service: "StrBirimHarcamaLimit/GetHarcananAndUstLimit", 
        Page: this.Page,
        Filter:Filter
        }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;


      });
    },

    loadOptions({ action,  callback }) {
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

          const options = this.FormDataType.Hesapkoduid.ComboDataArray;

          callback(null, options)
        })
      }
    },


    hesapkodu_sorgula(Aciklama){

      let Page= {
      PageNumber: "1",
      PageSize: "100"
    }

    if (Aciklama.length>=1){
   
            let Filter = "&Basamak=4&Aciklama="+Aciklama;
            this.FormDataType.Hesapkoduid.ComboDataArray=[];

            this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {  
              for(var i=0; i<res.Data.length; i++)
                {
                  this.FormDataType.Hesapkoduid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " " + res.Data[i].Aciklama})
                }    
            }); 
      }

    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    KalanTutar(Data){
      var KalanLimit = 0;
      KalanLimit = Data.ustlimit - Data.HarcananTutar;
      return KalanLimit.toFixed(2);
    }
  }, 
  created() {



      this.UserId = store.getters.["auth/TokenUserId"] 
    let YetkiSorgu = this.UserRolles.filter((item) =>
    item.includes("SuperAdmin") || item.includes("StrAdmin"));
      if (YetkiSorgu.length != 0){
        this.AdminRoleKontrol = true; 
      } 

    this.KullaniciBilgileri = store.getters.["auth/UserRolles"];


  },
};
</script>

<template>
  <Loader>
    <Layout>


      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer(),Filter.Hesapkoduid=null">
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("StrBirimHarcamaLimit.Page.Filtreleme") }}
                    </button>
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-if="AdminRoleKontrol" v-b-modal.StrBirimHarcamaLimit @click="(DataUpdate = StrBirimHarcamaLimitData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i> {{ $t("StrBirimHarcamaLimit.Page.YeniKayitEkle") }}</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("StrBirimHarcamaLimit.Table.Birimadi") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=Birimadi'" @click="siralama='&Asc=Birimadi', Get()" class="bx bx-sort-a-z fa-xl"></i>
                        <i style="margin-left:10px" v-if="siralama=='&Asc=Birimadi'" @click="siralama='&Desc=Birimadi', Get()" class="bx bx-sort-z-a  fa-xl"></i> 
                    
                      </th>
                      <th>{{ $t("StrBirimHarcamaLimit.Table.Hesapaciklama") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=Hesapkodu'" @click="siralama='&Asc=Hesapkodu', Get()" class="bx bx-sort-a-z fa-xl"></i>
                        <i style="margin-left:10px" v-if="siralama=='&Asc=Hesapkodu'" @click="siralama='&Desc=Hesapkodu', Get()" class="bx bx-sort-z-a  fa-xl"></i> 
                    
                      </th>
                      <th>{{ $t("StrBirimHarcamaLimit.Table.Yil") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=Yil'" @click="siralama='&Asc=Yil', Get()" class="bx bx-sort-a-z fa-xl"></i>
                        <i style="margin-left:10px" v-if="siralama=='&Asc=Yil'" @click="siralama='&Desc=Yil', Get()" class="bx bx-sort-z-a  fa-xl"></i> 
                    
                      </th>
                      <th>{{ $t("StrBirimHarcamaLimit.Table.Ustlimit") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=Ustlimit'" @click="siralama='&Asc=Ustlimit', Get()" class="bx bx-sort-a-z fa-xl"></i>
                        <i style="margin-left:10px" v-if="siralama=='&Asc=Ustlimit'" @click="siralama='&Desc=Ustlimit', Get()" class="bx bx-sort-z-a  fa-xl"></i> 
                    
                      </th>
                      <th>{{ $t("StrBirimHarcamaLimit.Table.KalanLimit") }}
                        <i style="margin-left:10px" v-if="siralama!='&Asc=Ustlimit'" @click="siralama='&Asc=Ustlimit', Get()" class="bx bx-sort-a-z fa-xl"></i>
                        <i style="margin-left:10px" v-if="siralama=='&Asc=Ustlimit'" @click="siralama='&Desc=Ustlimit', Get()" class="bx bx-sort-z-a  fa-xl"></i> 
                    
                      </th>
                      <th style="text-align: center;">{{ $t("StrBirimHarcamaLimit.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Birimadi }}</th>
                      <th scope="row">{{ Data.Hesapkodu }} - {{ Data.Hesapaciklama }}</th>
                      <th scope="row">{{ Data.yil }}</th>
                      <th scope="row" style="text-align: right;">{{ Data.ustlimit }}</th> 
                      <th scope="row" style="text-align: right;" v-if="Data.HarcananTutar == null">{{ Data.ustlimit }}</th> 
                      <th scope="row" style="text-align: right;" v-else>{{ KalanTutar(Data) }} </th> 
                      <td style="width: 85px; text-align: center;">
        
                          <b-button-group>
                            <b-button variant="primary" v-b-modal.StrUstLimitDetay
                            @click="DataUpdate2 = Data">
                                    <i class="fas fa-plus"></i>
                                  </b-button>   
                  
                        </b-button-group>




                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
 
      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
      <Detay :Id="DataUpdate2" v-if="DataUpdate2" :AdminRoleKontrol="AdminRoleKontrol"/>

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div  style="width: 400px;" v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrBirimHarcamaLimit.Filtreleme.Title") }}
            </h5>
          </div>
          <div >
            {{ $t("StrBirimHarcamaLimit.Filtreleme.Content") }}
            <br><br>
            
            <div class="mb-3">


   
                  <BirimSecimi
                    :title="$t('StrBirimHarcamaLimit.Filtreleme.Birimid')"
                    :sutun="'0'" 
                    :title_position="'mb-3'"
                    :selected="Filter.Birimid"
                    :labels_lg="'3'"  
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="Filter.Birimid=$event"
                  />
      



            </div>
            <div class="mb-3">


              <b-form-group class="mb-3" id="example text"  label="Hesap Kodları" label-for="text">
        
                <treeselect 
                style="width:400px"
                @search-change="hesapkodu_sorgula($event)"
                :async="true"
                :load-options="loadOptions"
                :multiple="false" 
                searchPromptText="Aramak için yazın..."
                
                placeholder="Seçiniz..." 
                v-model="Filter.Hesapkoduid" 
                          
                />
                <treeselect-value :value="Filter.Hesapkoduid" />
              </b-form-group>


            </div>
            <div class="mb-3">
              <forminput
                :FormDataType="{
                  FieldName: 'Yil',
                  Field: 'input',
                  FieldTitle: $t('StrBirimHarcamaLimit.Filtreleme.Yil') 
                }"
                :Value="Filter.Yil"
                :v="$v.Filter.Yil"
                @input="Filter.Yil = $event"
              />
            </div>

            <b-button @click="Get(),rightDrawer()" class="btn btn-primary" variant="primary"> {{ $t("StrBirimHarcamaLimit.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>

   
  </Loader>
</template>
